import { autoinject, LogManager } from "aurelia-framework";
import { IDatasource, IGetRowsParams } from "ag-grid";
import { HttpClientService } from "./http-client-service";
import { HttpResponseMessage } from "aurelia-http-client";

let log = LogManager.getLogger("GridAjaxDatasourceFactory");

@autoinject
export class DatasourceFactory {
  constructor(private httpClientService: HttpClientService) {}

  createDatasource(basePath: string): Datasource {
    return new Datasource(basePath, this.httpClientService);
  }
}

export class Datasource {
  constructor(
    private basePath: string,
    private httpClientService: HttpClientService,
  ) {}

  createGridDatasourceServerSideFiltering(
    queryParams?: () => any,
    defaultSortModel?: any,
  ) {
    return new GridDatasourceServerSideFiltering(
      this.basePath,
      this.httpClientService,
      queryParams,
      defaultSortModel,
    );
  }

  update(data: any): Promise<HttpResponseMessage> {
    return this.httpClientService
      .get()
      .configure((h) => {
        h.withResponseType("application/json");
      })
      .post(this.basePath + "/update", data)
      .then((r) => (r.isSuccess ? r : Promise.reject(r)));
  }

  downloadFile(id: number): Promise<HttpResponseMessage> {
    return this.httpClientService
      .get()
      .configure((h) => {
        h.withResponseType("blob");
      })
      .get(this.basePath + "/download/" + id) //, {"responseType": "blob"})
      .then((r) => (r.isSuccess ? r : Promise.reject(r)));
  }
}

export class GridDatasourceServerSideFiltering implements IDatasource {
  constructor(
    private basePath: string,
    private httpClientService: HttpClientService,
    private queryParams?: () => any,
    private defaultSortModel?: any,
  ) {}

  getRows(params: IGetRowsParams): void {
    this.httpClientService
      .get()
      .configure((h) => {
        h.withResponseType("application/json");
      })
      .post(this.basePath + this.queryString(), {
        start: params.startRow,
        end: params.endRow,
        sort:
          params.sortModel && params.sortModel.length > 0
            ? params.sortModel
            : this.defaultSortModel,
        filter: params.filterModel,
      })
      .then((r) => params.successCallback(r.content.result, r.content.total))
      .catch((e) => {
        log.error("error fetching data for grid", e);
        params.failCallback();
      });
  }

  queryString(): string {
    if (this.queryParams) {
      let params = this.queryParams();
      return (
        "?" +
        Object.keys(params)
          .map(
            (k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`,
          )
          .join("&")
      );
    } else {
      return "";
    }
  }
}
